<template>
	<div class="container">
		<div class="content">
			<div class="search">
				<div class="search-input">
					<i class="el-icon-search"></i>
					<input v-model="form.keyword" class="input" placeholder="请输入产品名称" @keyup.enter="handleSearch" />
				</div>
				<div class="search-btn" @click="handleSearch">
					<i class="el-icon-right"></i>
				</div>
			</div>

			<div class="product">
				<div class="product-tab">
					<el-tabs v-model="categoryName" @tab-click="handleParentCategoryChange">
						<el-tab-pane v-for="(item, index) in categoryList" :key="index" :label="item.name"
							:name="item.name" />
					</el-tabs>
				</div>
				<div class="product-classify">
					<div class="product-classify-item" :class="{ on: activeChildCategory === 'all' }"
						@click="handleChildCategoryChange('all')">
						全部
					</div>
					<div class="product-classify-item" v-for="(item, index) in currentChildCategories"
						:key="`child-${item.id}-${index}`" :class="{ on: isChildCategoryActive(item.id) }"
						@click="handleChildCategoryChange(item.id)">
						{{ item.name }}
					</div>
				</div>
				<div class="product-list">
					<div class="product-item" v-for="(item, index) in list" :key="index"
						@click="goDetail(item)">
						<div class="product-image">
							<el-image fit="cover" :src="$img(item.main_image)" />
						</div>
						<div class="product-info">
							<div class="product-name">
								{{ item.name }}
							</div>
							<div class="product-explain">
								{{ item.intro }}
							</div>
							<div class="product-label" v-for="(explain, explainIndex) in item.explain"
								:key="explainIndex">
								<el-image :src="require('@/../static/icon/shield.png')" />
								<div>
									{{ explain.name }}
								</div>
							</div>
							<div class="product-bottom">
								<div class="product-price">
									{{ item.price }}<span>元/起</span>
								</div>
								<div class="product-btn">
									了解详情
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 空状态提示 -->
				<div class="empty-state" v-if="list.length === 0">
					<el-empty description="暂无相关产品" />
				</div>

				<div class="pagination" v-if="list.length > 0 && total > form._size">
					<el-pagination background layout="prev, pager, next, total" :total="total" :page-size="form._size"
						:current-page="form._page" @current-change="currentChange" />
				</div>
			</div>
		</div>
		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';

	export default {
		name: 'InsureIndex',
		components: {
			mainFooter,
		},
		data() {
			return {
				form: {
					_page: 1,
					_size: 10,
					_order: 'sort',
					_isreverse: 1,
					category_ids: [],
					keyword: '',
				},
				list: [],
				total: 0,
				categoryName: '全部',
				categoryList: [{
					id: '',
					name: '全部'
				}],
				activeChildCategory: 'all',
				currentChildCategories: [],
				allChildCategories: [],
			};
		},
		watch: {
			'$route.query.category_id': {
				handler(newCategoryId) {
					if (newCategoryId && this.categoryList.length > 1) {
						this.selectCategoryById(newCategoryId);
					}
				},
				immediate: false
			}
		},
		mounted() {
			this.getTreeCategoryList();
		},
		methods: {
			currentChange(e) {
				this.form._page = e;
				this.ActionList();
			},

			isChildCategoryActive(categoryId) {
				return this.activeChildCategory === String(categoryId);
			},

			handleSearch() {
				this.categoryName = '全部';
				this.activeChildCategory = 'all';
				this.form.category_ids = [];
				this.form._page = 1;
				this.updateChildCategories();
				this.ActionList();
			},

			getTreeCategoryList() {
				this.$get('treeCategoryList').then(res => {
					this.categoryList = this.categoryList.concat(res.data);
					this.collectAllChildCategories();
					this.updateChildCategories();
					this.handleRouteParams();
				}).catch(err => {
					this.$message.error(err);
				});
			},

			handleRouteParams() {
				const query = this.$route.query;
				const categoryId = query.category_id;

				if (categoryId) {
					this.selectCategoryById(categoryId);
				} else {
					this.ActionList();
				}
			},

			selectCategoryById(categoryId) {
				const childCategory = this.allChildCategories.find(item => String(item.id) === String(categoryId));
				if (childCategory) {
					const parentCategory = this.categoryList.find(item =>
						item.children && item.children.some(child => String(child.id) === String(categoryId))
					);

					if (parentCategory) {
						this.categoryName = parentCategory.name;
						this.updateChildCategories();
						this.activeChildCategory = String(categoryId);
						this.form.category_ids = [categoryId];
						this.form._page = 1;
						this.ActionList();
						return;
					}
				}

				const parentCategory = this.categoryList.find(item => String(item.id) === String(categoryId));
				if (parentCategory && parentCategory.id) {
					this.categoryName = parentCategory.name;
					this.updateChildCategories();
					this.activeChildCategory = 'all';
					this.form.category_ids = [categoryId];
					this.form._page = 1;
					this.ActionList();
					return;
				}

				this.categoryName = '全部';
				this.activeChildCategory = 'all';
				this.form.category_ids = [];
				this.form._page = 1;
				this.updateChildCategories();
				this.ActionList();
			},

			collectAllChildCategories() {
				this.allChildCategories = [];
				for (let i = 1; i < this.categoryList.length; i++) {
					const category = this.categoryList[i];
					if (category.children && category.children.length > 0) {
						this.allChildCategories = this.allChildCategories.concat(category.children);
					}
				}
			},

			handleParentCategoryChange(tab) {
				const index = tab.index;
				const categoryItem = this.categoryList[index];
				const categoryId = categoryItem ? categoryItem.id : '';

				this.form.category_ids = [];
				this.form.keyword = '';

				if (categoryId) {
					this.form.category_ids.push(categoryId);
				}

				this.updateChildCategories();
				this.activeChildCategory = 'all';
				this.form._page = 1;
				this.ActionList();
			},

			handleChildCategoryChange(categoryId) {
				// 检查点击的分类是否存在
				if (categoryId !== 'all') {
					const clickedCategory = this.currentChildCategories.find(item => item.id === categoryId);
					if (!clickedCategory) {
						return;
					}
				}

				this.activeChildCategory = String(categoryId);
				this.form.category_ids = [];
				this.form.keyword = '';

				if (categoryId !== 'all') {
					this.form.category_ids.push(categoryId);
				} else {
					const activeParent = this.categoryList.find(item => item.name === this.categoryName);
					if (activeParent && activeParent.id) {
						this.form.category_ids.push(activeParent.id);
					}
				}

				this.form._page = 1;
				this.ActionList();
			},

			updateChildCategories() {
				if (this.categoryName === '全部') {
					this.currentChildCategories = this.allChildCategories;
				} else {
					const activeCategory = this.categoryList.find(item => item.name === this.categoryName);
					if (activeCategory && activeCategory.children) {
						this.currentChildCategories = activeCategory.children;
					} else {
						this.currentChildCategories = [];
					}
				}
			},

			goDetail(item) {
				const userInfo = this.$getter('UserInfo');
				if (!(userInfo && userInfo.id)) {
					this.$warning('请先登录后查看详情');
					this.$vuex('loginVisible', true, true);  // 弹出登录弹窗
					return;
				}
				this.$navto('/insure/detail?id=' + item.id);
			},

			ActionList() {
				// 显示加载动画
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				const params = {
					...this.form,
					category_ids: this.form.category_ids.toString()
				};

				this.$get('app-goods', params, true).then(res => {
					this.list = res.data;
					this.total = res.extra.pageInfo.count;
				}).catch(err => {
					this.$message.error(err);
				}).finally(() => {
					// 无论成功失败都关闭加载动画
					loading.close();
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;
		min-height: 100vh;
		background-repeat: no-repeat;
		background-image: linear-gradient(to bottom,
				transparent 60%,
				rgba(247, 247, 247, 1)),
			url('../../../../static/insure/bg.png');
		background-size: 100% 400px;

		.content {
			padding-top: 60px;
			margin: 0 auto 40px;
			width: 90%;
			min-height: 100vh;

			@media (min-width: 1441px) {
				width: 68%;
			}

			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 85%;
			}

			@media (max-width: 1023px) and (min-width: 768px) {
				width: 95%;
				padding-top: 40px;
			}

			@media (max-width: 767px) {
				width: 100%;
				padding: 20px 15px 0;
			}

			.search {
				width: 80%;
				margin: 0 auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 15px;
				background-color: #fff;
				border-radius: 50px;
				border: 1px solid #2280FD;

				@media (min-width: 1024px) and (max-width: 1440px) {
					width: 90%;
				}

				@media (max-width: 1023px) and (min-width: 768px) {
					width: 95%;
				}

				@media (max-width: 767px) {
					width: 100%;
					padding: 12px;
					border-radius: 30px;
				}

				.search-input {
					display: flex;
					align-items: center;
					width: 90%;
					gap: 10px;

					.el-icon-search {
						font-size: 24px;
						color: #999999;

						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 22px;
						}

						@media (max-width: 1023px) and (min-width: 768px) {
							font-size: 20px;
						}

						@media (max-width: 767px) {
							font-size: 18px;
						}
					}

					.input {
						border: none !important;
						width: 100%;
						font-size: 16px;
						outline: none;

						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 15px;
						}

						@media (max-width: 1023px) and (min-width: 768px) {
							font-size: 14px;
						}

						@media (max-width: 767px) {
							font-size: 14px;
						}
					}
				}

				.search-btn {
					background-color: #2280FD;
					color: #fff;
					font-size: 18px;
					border-radius: 50px;
					width: 35px;
					height: 35px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					transition: all 0.3s ease;

					@media (min-width: 1024px) and (max-width: 1440px) {
						width: 32px;
						height: 32px;
						font-size: 16px;
					}

					@media (max-width: 1023px) and (min-width: 768px) {
						width: 30px;
						height: 30px;
						font-size: 15px;
					}

					@media (max-width: 767px) {
						width: 28px;
						height: 28px;
						font-size: 14px;
					}

					&:hover {
						background-color: #1a6fd8;
						transform: scale(1.05);
					}
				}
			}

			.product {
				width: 100%;
				background-color: #fff;
				padding: 30px;
				border-radius: 15px;
				margin-top: 40px;
				box-sizing: border-box;

				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 25px;
					margin-top: 35px;
				}

				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 20px;
					margin-top: 30px;
				}

				@media (max-width: 767px) {
					padding: 15px;
					margin-top: 20px;
					border-radius: 10px;
				}

				.product-tab {
					:deep(.el-tabs) {
						.el-tabs__item {
							font-size: 16px;
							color: #999999;

							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 15px;
								padding: 0 15px;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								font-size: 14px;
								padding: 0 12px;
							}

							@media (max-width: 767px) {
								font-size: 13px;
								padding: 0 8px;
							}
						}

						.el-tabs__item.is-active {
							color: #2280FD;
						}

						.el-tabs__active-bar {
							background-color: #2280FD;
						}
					}
				}

				.product-classify {
					display: flex;
					flex-wrap: wrap;
					gap: 15px;
					margin-top: 20px;

					@media (min-width: 1024px) and (max-width: 1440px) {
						gap: 12px;
						margin-top: 18px;
					}

					@media (max-width: 1023px) and (min-width: 768px) {
						gap: 10px;
						margin-top: 15px;
					}

					@media (max-width: 767px) {
						gap: 8px;
						margin-top: 12px;
					}

					.product-classify-item {
						border-radius: 50px;
						padding: 5px 15px;
						font-size: 14px;
						background-color: #F7F7F7;
						border: 1px solid #F7F7F7;
						color: #999999;
						cursor: pointer;
						transition: all 0.3s ease;
						user-select: none;

						/* 确保所有分类项都可点击 */
						pointer-events: auto !important;
						position: relative;
						z-index: 1;

						@media (min-width: 1024px) and (max-width: 1440px) {
							padding: 4px 12px;
							font-size: 13px;
						}

						@media (max-width: 1023px) and (min-width: 768px) {
							padding: 4px 10px;
							font-size: 12px;
						}

						@media (max-width: 767px) {
							padding: 3px 8px;
							font-size: 11px;
						}

						/* 修复点击区域 */
						&::after {
							content: '';
							position: absolute;
							top: -5px;
							left: -5px;
							right: -5px;
							bottom: -5px;
							z-index: -1;
						}

						&:hover {
							border-color: #2280FD;
							color: #2280FD;
							background-color: #F1FAFF;
						}

						/* 激活状态反馈 */
						&:active {
							transform: scale(0.98);
						}
					}

					.on {
						background-color: #F1FAFF;
						border: 1px solid #2280FD;
						color: #2280FD;
					}
				}

				.product-list {
					margin-top: 20px;
					display: flex;
					gap: 20px;
					flex-wrap: wrap;

					@media (min-width: 1024px) and (max-width: 1440px) {
						gap: 15px;
						margin-top: 18px;
					}

					@media (max-width: 1023px) and (min-width: 768px) {
						gap: 12px;
						margin-top: 15px;
					}

					@media (max-width: 767px) {
						gap: 10px;
						margin-top: 12px;
					}

					.product-item {
						display: flex;
						width: calc(50% - 10px);
						background-color: #fff;
						padding: 12px;
						border-radius: 15px;
						cursor: pointer;
						transition: all 0.3s ease;
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
						box-sizing: border-box;
						overflow: hidden;

						@media (min-width: 1024px) and (max-width: 1440px) {
							width: calc(50% - 7.5px);
							padding: 10px;
							border-radius: 12px;
						}

						@media (max-width: 1023px) and (min-width: 768px) {
							width: calc(50% - 6px);
							padding: 8px;
							border-radius: 10px;
						}

						@media (max-width: 767px) {
							width: 100%;
							padding: 10px;
							border-radius: 8px;
							flex-direction: column;
						}

						&:hover {
							transform: translateY(-5px);
							box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
						}

						.product-image {
							.el-image {
								border-radius: 10px;
								width: 200px;
								height: 230px;
								max-width: 100%;
								object-fit: cover;

								@media (min-width: 1024px) and (max-width: 1440px) {
									width: 160px;
									height: 180px;
									border-radius: 8px;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									width: 130px;
									height: 150px;
									border-radius: 6px;
								}

								@media (max-width: 767px) {
									width: 100%;
									height: 160px;
									border-radius: 6px;
								}
							}

							width: 40%;
							flex-shrink: 0;
							display: flex;
							justify-content: center;
							align-items: flex-start;

							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 160px;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								width: 130px;
							}

							@media (max-width: 767px) {
								width: 100%;
								margin-bottom: 8px;
							}
						}

						.product-info {
							width: 58%;
							flex: 1;
							min-width: 0;
							padding-left: 15px;
							box-sizing: border-box;

							@media (min-width: 1024px) and (max-width: 1440px) {
								width: calc(100% - 160px);
								padding-left: 15px;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								width: calc(100% - 130px);
								padding-left: 12px;
							}

							@media (max-width: 767px) {
								width: 100%;
								padding-left: 0;
								padding-top: 10px;
							}

							.product-name {
								color: #333333;
								font-weight: bold;
								font-size: 18px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;

								@media (min-width: 1024px) and (max-width: 1440px) {
									font-size: 16px;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									font-size: 15px;
								}

								@media (max-width: 767px) {
									font-size: 16px;
								}
							}

							.product-explain {
								color: #999999;
								font-size: 14px;
								margin-top: 5px;

								/* 多行文本溢出隐藏 */
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
								overflow: hidden;
								text-overflow: ellipsis;
								line-height: 1.4;
								/* 确保在移动端也能正确显示 */
								min-height: 2.8em;

								@media (min-width: 1024px) and (max-width: 1440px) {
									font-size: 13px;
									margin-top: 4px;
									line-height: 1.3;
									min-height: 2.6em;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									font-size: 12px;
									margin-top: 3px;
									line-height: 1.3;
									min-height: 2.6em;
								}

								@media (max-width: 767px) {
									font-size: 13px;
									margin-top: 4px;
									line-height: 1.3;
									min-height: 2.6em;
								}
							}

							.product-label {
								display: flex;
								align-items: center;
								gap: 5px;
								font-size: 16px;
								color: #666666;
								margin-top: 10px;

								@media (min-width: 1024px) and (max-width: 1440px) {
									font-size: 14px;
									margin-top: 8px;
									gap: 4px;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									font-size: 13px;
									margin-top: 6px;
									gap: 3px;
								}

								@media (max-width: 767px) {
									font-size: 14px;
									margin-top: 8px;
									gap: 4px;
								}

								.el-image {
									width: 15px;
									height: 15px;

									@media (min-width: 1024px) and (max-width: 1440px) {
										width: 13px;
										height: 13px;
									}

									@media (max-width: 1023px) and (min-width: 768px) {
										width: 12px;
										height: 12px;
									}

									@media (max-width: 767px) {
										width: 13px;
										height: 13px;
									}
								}

								div {
									width: 100%;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}

							.product-bottom {
								display: flex;
								justify-content: space-between;
								align-items: center;
								margin-top: 30px;
								margin-left: 20px;

								@media (min-width: 1024px) and (max-width: 1440px) {
									margin-top: 20px;
									margin-left: 15px;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									margin-top: 15px;
									margin-left: 10px;
								}

								@media (max-width: 767px) {
									margin-top: 15px;
									margin-left: 0;
								}

								.product-price {
									color: #FF2B2B;
									font-weight: bold;
									font-size: 32px;

									@media (min-width: 1024px) and (max-width: 1440px) {
										font-size: 26px;
									}

									@media (max-width: 1023px) and (min-width: 768px) {
										font-size: 22px;
									}

									@media (max-width: 767px) {
										font-size: 24px;
									}

									span {
										font-weight: 500;
										font-size: 20px;

										@media (min-width: 1024px) and (max-width: 1440px) {
											font-size: 16px;
										}

										@media (max-width: 1023px) and (min-width: 768px) {
											font-size: 14px;
										}

										@media (max-width: 767px) {
											font-size: 16px;
										}
									}
								}

								.product-btn {
									background-color: #2280FD;
									width: 110px;
									line-height: 40px;
									border-radius: 50px;
									color: #fff;
									text-align: center;
									transition: all 0.3s ease;

									@media (min-width: 1024px) and (max-width: 1440px) {
										width: 95px;
										line-height: 34px;
										font-size: 14px;
									}

									@media (max-width: 1023px) and (min-width: 768px) {
										width: 85px;
										line-height: 30px;
										font-size: 13px;
										border-radius: 40px;
									}

									@media (max-width: 767px) {
										width: 90px;
										line-height: 32px;
										font-size: 14px;
									}

									&:hover {
										background-color: #1a6fd8;
									}
								}
							}
						}
					}
				}

				.empty-state {
					display: flex;
					justify-content: center;
					align-items: center;
					height: 200px;

					@media (min-width: 1024px) and (max-width: 1440px) {
						height: 180px;
					}

					@media (max-width: 767px) {
						height: 150px;
					}
				}

				.pagination {
					display: flex;
					justify-content: center;
					margin-top: 30px;

					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-top: 25px;
					}

					@media (max-width: 767px) {
						margin-top: 20px;
					}

					::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
						background-color: #2280FD;
						color: white;
					}

					::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
						color: #2280FD;
					}
				}
			}
		}
	}
</style>